import MenuItemAllergens from './MenuItemAllergens'

export default MenuItemAllergens
